<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} công ty lữ hành</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} công ty lữ hành</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} công ty lữ hành</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="2">
              <b-row>
                <b-col md="12">
                  <el-form-item class="mb-4" label="Ảnh đại diện">
                    <el-upload
                      action
                      :auto-upload="false"
                      list-type="picture-card"
                      :limit="mData.fileUploadOption.AnhDaiDien.limit"
                      :accept="mData.fileUploadOption.AnhDaiDien.accept"
                      :on-change="fn_uploadChangeAnhDaiDien"
                      :on-preview="fn_uploadPreviewAnhDaiDien"
                      :on-remove="fn_uploadRemoveAnhDaiDien"
                      :on-exceed="fn_uploadExceedAnhDaiDien"
                      :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                      :disabled="mData.viewMode == 'detail'"
                      :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog
                      :close-on-click-modal="true"
                      :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                      width="60%"
                      top="51px"
                      title="Chi tiết"
                    >
                      <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                    </el-dialog>
                  </el-form-item>
                  <div v-if="mData.dataDefault.rate != null">
                    <h2 align="center">{{mData.dataDefault.rate}}</h2>
                    <el-rate
                      align="center"
                      v-model="mData.dataDefault.star"
                      disabled
                      :colors="['#0373fc','#0373fc','#ffffff']"
                    ></el-rate>
                    <p align="center">{{mData.dataDefault.amountRate}} đánh giá</p>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="10">
              <b-row>
                <b-col md="11">
                  <el-form-item label="Tên tiếng Việt" prop="ten.vi">
                    <el-input
                      v-model="mData.dataForm.ten.vi"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="1">
                  <el-form-item label="Khóa" prop="isDisabled">
                    <el-checkbox
                      v-model="mData.dataForm.isDisabled"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                    ></el-checkbox>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item label="Tên tiếng Anh" prop="ten.en">
                    <el-input
                      v-model="mData.dataForm.ten.en"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Hotline" prop="hotline">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.hotline"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      v-model="mData.dataForm.email"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Điện thoại" prop="dien_thoai">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dien_thoai"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Website" prop="website">
                    <el-input
                      v-model="mData.dataForm.website"
                      :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row v-if="mData.viewMode != 'detail'">
            <b-col md="6">
              <el-form-item label="Người quản lý">
                <el-select
                  v-model="mData.dataDefault.itemNguoiQuanLy"
                  placeholder="Nhập từ khóa để tìm kiếm (họ tên, email, số điện thoại)"
                  :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                  @change="fn_addNguoiQuanLy(mData.dataDefault.itemNguoiQuanLy)"
                  clearable
                  filterable
                  no-data-text="Chưa có dữ liệu"
                  :filter-method="fn_remoteGetListNguoiQuanLy"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNguoiQuanLy"
                    :key="item.id"
                    :label="item.ho_ten.ho_ten+ ' - Email: ' + (item.email?item.email:'')+' - Điện thoại: ' +(item.dien_thoai?item.dien_thoai:'')"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12" class="mb-2">Danh sách người quản lý</b-col>
            <div class="col-md-12">
              <el-table
                :data="mData.dataDefault.listNguoiQuanLyTable"
                border
                max-height="440"
                style="width: 100%; display: grid;"
              >
                <el-table-column prop="ho_ten.ho_ten" label="Họ tên" width="auto" min-width="150"></el-table-column>
                <el-table-column prop="email" label="Email" width="250"></el-table-column>
                <el-table-column prop="dien_thoai" label="Điện thoại" width="150" align="left"></el-table-column>
                <el-table-column prop="gioi_tinh" label="Giới tính" width="150" align="center"></el-table-column>
                <el-table-column
                  :label="aLang.c_action"
                  align="center"
                  width="100px"
                  v-if="mData.viewMode != 'detail'"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="fn_deleteNguoiQuanLy(scope.$index)"
                      v-b-popover.hover.left="aLang.c_delete"
                    >
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                <el-input
                  v-model="mData.dataForm.dia_chi.dia_chi"
                  :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <el-form-item
                label="Số giấy phép kinh doanh lữ hành"
                prop="giay_phep_kinh_doanh.so_giay_phep"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.giay_phep_kinh_doanh.so_giay_phep"
                  :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item
                label="Nơi cấp giấy phép kinh doanh"
                prop="giay_phep_kinh_doanh.noi_cap"
              >
                <el-input
                  v-model="mData.dataForm.giay_phep_kinh_doanh.noi_cap"
                  :disabled="mData.viewMode == 'detail' || aRole('TourAgent')"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item label="Slogan " prop="slogan">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.slogan"
                  :disabled="mData.viewMode == 'detail'"
                  rows="6"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import CongTyLuHanhModel from "./CongTyLuHanhModel";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import ExtensionService from "../../../service/ExtensionService";
// import { debug } from "util";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "CongTyLuHanh",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listNguoiQuanLy: [],
          textFindNguoiQuanLy: "",
          listNguoiQuanLyTable: [],
          itemNguoiQuanLy: null,
          rate: null,
          amountRate: null
        },
        dataForm: MethodService.copyObject(CongTyLuHanhModel.dataForm),
        validForm: CongTyLuHanhModel.validForm,
        dialog: {},
        fileUploadOption: {
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await CongTyLuHanhApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await CongTyLuHanhApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await CongTyLuHanhApi.findById(id);

      // let resNew = MethodService.checkDifferentObject(
      //   MethodService.copyObject(CongTyLuHanhModel.dataForm),
      //   res.result
      // );
      let resDanhGia = await CongTyLuHanhApi.countDanhGia();
      let resNew = res.result;
      if (resNew.avatar_id) {
        let data = {
          id: resNew.avatar_id,
          name: resNew.avatar_id,
          url: ExtensionService.urlImg + resNew.avatar_id
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }

      if (resNew.nguoi_quan_ly_ids && resNew.nguoi_quan_ly_ids.length > 0) {
        let resProfileApi = await ProfileApi.list({
          limit: resNew.nguoi_quan_ly_ids.length,
          filters: "id:in:" + resNew.nguoi_quan_ly_ids.join(",")
        });
        this.mData.dataDefault.listNguoiQuanLyTable = resProfileApi.result;
        this.changeData(this.mData.dataDefault.listNguoiQuanLyTable);
      }

      if (resDanhGia.result && resNew.id) {
        let saodanhgia = resDanhGia.result.find(
          item => item.cong_ty_lu_hanh_id == resNew.id
        );
        if (saodanhgia) {
          this.mData.dataDefault.rate = parseFloat(
            saodanhgia.tong_sao / saodanhgia.tong_so_tour
          ).toFixed(1);
          this.mData.dataDefault.star =
            saodanhgia.tong_sao / saodanhgia.tong_so_tour;
          this.mData.dataDefault.amountRate = saodanhgia.tong_so_tour;
        }
      }
      //get viewStatics
      // let resView = await CongTyLuHanhApi.getViewStatistics();
      // let resViewData = resView.result;

      // let resViewDanhGia = await DanhGiaApi.getCompanyStar();
      // let resViewDataDanhGia = resViewDanhGia.result;
      //

      this.mData.dataForm = resNew;

      // let resProfileApi = await ProfileApi.list({
      //     limit: 1000,
      //     filters: "id:in:"+ resNew.nguoi_quan_ly_ids.join(",")
      //   });
      // this.mData.dataDefault.listNguoiQuanLy = resProfileApi.result;
    },
    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }
      });
      return data;
    },
    async fn_initDataDefault() {
      let Province = await ProvinceApi.list({ limit: 1000 });
      this.mData.dataDefault.listProvince = Province.result;

      // let Profile = await ProfileApi.list({ limit: 1000 });
      // this.mData.dataDefault.listNguoiQuanLy = Profile.result;
    },

    // async fn_remoteGetListNguoiQuanLy(query) {
    //   if (query && query.length > 0) {
    //     let query1 = query
    //       .replace("*", "\\*")
    //       .replace("$", "\\$")
    //       .replace("%", "\\*")
    //       .replace("[", "\\[")
    //       .replace("]", "\\]")
    //       .replace("^", "\\^");
    //     let resProfileApi = await ProfileApi.list({
    //       limit: 1000,
    //       filters: `ho_ten.ho_ten:regex_i:${query1}`
    //     });
    //     let listFindNguoiQuanLy=resProfileApi.result
    //     let listTemp=this.mData.dataDefault.listNguoiQuanLy;
    //     this.mData.dataDefault.listNguoiQuanLy = listFindNguoiQuanLy;

    //     // this.mData.dataDefault.listNguoiQuanLy=listFindNguoiQuanLy;
    //   }
    // },

    // async fn_selectData(id) {
    //     let resProfileApi = await ProfileApi.list({
    //       limit: 1000,
    //       filters: "id:in:"+ this.mData.dataForm.nguoi_quan_ly_ids.join(",")
    //     });
    //        debugger
    //   this.mData.dataDefault.listNguoiQuanLy = resProfileApi.result;
    // },

    async fn_remoteGetListNguoiQuanLy(query) {
      if (query) {
        let resProfileApi = await ProfileApi.list({
          limit: 1000,
          filters: `ho_ten.ho_ten:regex_i:${query}|email:regex_i:${query}|dien_thoai:regex_i:${query}`
        });

        if (resProfileApi.result && resProfileApi.result.length) {
          this.mData.dataDefault.listNguoiQuanLy = resProfileApi.result;
        }
      }
    },
    // async fn_enterFindNguoiQuanLy() {
    //   if (this.mData.dataDefault.textFindNguoiQuanLy) {
    //     let resProfileApi = await ProfileApi.list({
    //       limit: 1000,
    //       filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindNguoiQuanLy}`
    //     });

    //     if (resProfileApi.result && resProfileApi.result.length) {
    //       this.mData.dataDefault.listNguoiQuanLy = resProfileApi.result;
    //     } else {

    //     }
    //   }
    // },

    fn_addNguoiQuanLy(item) {
      if (item) {
        var flag = false;
        $.each(
          this.mData.dataDefault.listNguoiQuanLyTable,
          (index, element) => {
            if (item.id == element.id) {
              flag = true;
            }
          }
        );
        if (flag) {
          toastr.info("Đã tồn tại người quản lý này");
        } else {
          if (item.id) {
            this.mData.dataDefault.listNguoiQuanLyTable.push(item);
            this.changeData(this.mData.dataDefault.listNguoiQuanLyTable);
            this.mData.dataForm.nguoi_quan_ly_ids.push(item.id);
          }
        }

        this.mData.dataDefault.itemNguoiQuanLy = null;
        this.mData.dataDefault.listNguoiQuanLy = [];
      }
    },

    fn_deleteNguoiQuanLy(index) {
      this.$confirm(LanguageService.lang.c_deleteConfirm, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning"
      })
        .then(() => {
          var itemDel = this.mData.dataDefault.listNguoiQuanLyTable[index];
          this.mData.dataDefault.listNguoiQuanLyTable.splice(index, 1);
          $.each(this.mData.dataForm.nguoi_quan_ly_ids, (i, item) => {
            if (itemDel.id == item) {
              this.mData.dataForm.nguoi_quan_ly_ids.splice(i, 1);
              return false; // breaks
            }
          });
        })
        .catch(() => {});
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file, size) {
      return MethodService.checkFileSize(file, size);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.avatar_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "toucongtyluhanhr")
        .then(res => {
          this.mData.dataForm.avatar_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>